import { useQuery } from '@tanstack/react-query';
import { useApi } from './useApi.ts';

export interface MeResponse {
  id: string;
  email: string;
  name: string | null;
  role: 'admin' | 'viewer';
  status: 'pending' | 'active' | 'denied';
}

/**
 * Current user record from the gateway. Drives the approval gate in App.tsx
 * (pending/denied users never see the app shell) and hides admin-only nav for
 * viewers. Polled every 30s so an admin approving another tab gets picked up
 * without requiring a hard reload.
 */
export function useMe() {
  const { request } = useApi();
  return useQuery({
    queryKey: ['me'],
    queryFn: () => request<MeResponse>('/admin/me'),
    // Pending/denied users see the waiting screen — refreshing lets them
    // progress the moment an admin approves, no refresh button needed.
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
